export default __webpack_public_path__ + "static/media/fullscreen.159f8f91.svg";